"use client"

import ArrowBack from "@/assets/vectors/ArrowBack"
import BoltFilled from "@/assets/vectors/BoltFilled"
import Button from "@/components/button/Button"
import { motion } from "motion/react"
import { useEffect, useState } from "react"
import styles from "./error.module.scss"

const shakeConfigs = [
    {
        x: [0, -5, 4, -3, 2, -4, 3, -2, 0],
        y: [0, 3, -4, 2, -3, 4, -2, 3, 0],
        duration: 0.5,
        delay: 0,
    },
    {
        x: [0, 4, -5, 3, -2, 5, -3, 2, 0],
        y: [0, -3, 5, -4, 2, -3, 4, -2, 0],
        duration: 0.45,
        delay: 0.2,
    },
    {
        x: [0, -3, 5, -4, 3, -2, 4, -5, 0],
        y: [0, 4, -3, 5, -4, 2, -3, 2, 0],
        duration: 0.55,
        delay: 0.1,
    },
]

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    const [digits, setDigits] = useState(["5", "0", "0"])
    const errorId = error.digest || Math.random().toString(16).slice(2, 10).toUpperCase()

    useEffect(() => {
        const glitch = setInterval(() => {
            setDigits(prev =>
                prev.map(d =>
                    Math.random() > 0.6
                        ? "!@#$%^&*_+-=[]{}|;:',.></~"[Math.floor(Math.random() * 28)]
                        : d,
                ),
            )
            setTimeout(() => setDigits(["5", "0", "0"]), 150)
        }, 3500)

        return () => clearInterval(glitch)
    }, [])

    return (
        <main className={styles.page} id="main-content">
            <div className={styles.pattern} />
            <div className={styles.gradient_bg} />
            <div className={styles.scanline} />
            <div className={styles.scanline_overlay} />
            <div className={styles.particles} />

            <div className={styles.content}>
                <div className={styles.badge}>
                    <span className={styles.pulse} />
                    CRITICAL CASCADE // 500
                </div>

                <div className={styles.digits}>
                    {[0, 1, 2].map(i => (
                        <motion.span
                            key={i}
                            className={styles.digit}
                            data-digit={digits[i]}
                            animate={{
                                x: shakeConfigs[i].x,
                                y: shakeConfigs[i].y,
                            }}
                            transition={{
                                duration: shakeConfigs[i].duration,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: shakeConfigs[i].delay,
                            }}
                        >
                            {digits[i]}
                        </motion.span>
                    ))}
                </div>

                <p className={styles.message}>
                    The system encountered an <strong>unexpected state</strong> and couldn&apos;t
                    recover.
                    <br />
                    Try again or return to safety.
                </p>

                <p className={styles.subtext}>Error 500 &middot; Containment Breach</p>
                <p className={styles.error_id}>{errorId}</p>

                <div className={styles.actions}>
                    <Button
                        label="Retry System"
                        onClick={() => reset()}
                        startIcon={BoltFilled}
                    />
                    <Button
                        label="Return Home"
                        href="/"
                        startIcon={ArrowBack}
                        style="bezeled_gray"
                    />
                </div>
            </div>
        </main>
    )
}
